import {h, Fragment} from "preact"
import { useAppStateSelector } from "@nosto/preact"

export default function NoResults() {
    const query = useAppStateSelector(state => state.response.query)

    return (
        <div class="ns-noresults">
            <p class="ns-noresults-text" role="status">No results found for '{query}'</p>
            <nosto-campaign id="notfound-nosto-1" />
        </div>
    )
}